module.exports = __webpack_public_path__ + "static/media/sms-text-mock.548f2125.png";